import React, { useState, useEffect, useRef } from 'react';
import { ExternalLink } from 'lucide-react';
import '../styles/style.css';
import '../styles/mediaqueries.css';
import aboutMePic from '../assets/aboutMe.jpg';

function About() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.fade-up').forEach(el => {
                            el.classList.add('visible');
                        });
                    }
                });
            },
            { threshold: 0.1 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    const cards = [
        {
            icon: '🔧',
            title: 'Backend Engineering',
            content: 'Designing scalable APIs, microservices, and IoT pipelines. Flask, Docker, RabbitMQ — built for production.',
        },
        {
            icon: '🎓',
            title: 'Education',
            content: (
                <>
                    <p style={{ marginBottom: '0.3rem' }}>B.Sc. Computer Science<br />Machakos University</p>
                    <p>Data Science — Moringa School</p>
                    <a
                        href="https://moringa.my.salesforce-sites.com/certificateStatus?id=a0PQ200000ClXw4"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cert-link"
                    >
                        <ExternalLink size={12} />
                        Verify Certificate
                    </a>
                </>
            ),
        },
        {
            icon: '🤖',
            title: 'Robotics & IoT',
            content: 'Where software meets the physical world. Embedded systems, sensor networks, and autonomous control.',
        },
        {
            icon: '🎮',
            title: 'Creative Pursuits',
            content: '3D design and game development fuel creative thinking. Technology and art — always in parallel.',
        },
    ];

    return (
        <section id="about" ref={sectionRef}>
            <div className="scan-line" />

            <p className="section__text__p1">Get To Know More</p>
            <h1 className="title">About Me</h1>

            <div className="section-container">
                {/* ── PHOTO ── */}
                <div className="section__pic-container about-img fade-up">
                    <img
                        src={aboutMePic}
                        alt="Samwel Waithaka"
                        className="about-pic"
                        draggable={false}
                        onContextMenu={(e) => e.preventDefault()}
                        style={{userSelect: 'none', pointerEvents: 'auto'}}
                    />
                </div>

                {/* ── CONTENT ── */}
                <div className="about-details-container">
                    {/* Cards */}
                    <div className="about-containers">
                        {cards.map(({icon, title, content}) => (
                            <div className="details-container fade-up" key={title}>
                                <div style={{
                                    fontSize: '1.5rem',
                                    marginBottom: '0.6rem',
                                    lineHeight: 1,
                                }}>
                                    {icon}
                                </div>
                                <h3>{title}</h3>
                                {typeof content === 'string' ? <p>{content}</p> : content}
                            </div>
                        ))}
                    </div>

                    {/* Bio */}
                    <div className="text-container fade-up">
                        <p>
                            I’m Samwel Waithaka, a Software Engineer specializing in backend systems, APIs, and integrations. I help businesses build reliable, scalable digital products by designing robust systems and delivering production-ready solutions. My work extends to IoT and robotics, connecting software with real-world systems to create impactful, tangible results.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;